import {AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {
  firstNestedSymbolControl,
  getHTMLControlName,
  Wertemenge
} from '../../../models/uiArtefakt';
import {ValidationService} from '../../../services/validation.service';
import {UiUpdateService} from '../../../services/ui-update.service';
import {ISymbol, RuntimeContext} from '@lv1871/core';
import {ShellConfigService} from '../../../services/shell-config.service';
import {UIAusrichtung} from '../../../models/uiAusrichtung';
import {v4 as uuid} from 'uuid';
import {EventService} from '../../../services/event.service';
import {FondsService} from '../../../services/fonds.service';
import {FondsAnlagestrategie} from '../../../models/fondsAnlagestrategie';
import {MatDialog} from '@angular/material/dialog';
import {filter, switchMap, take} from 'rxjs/operators';
import {tap} from 'rxjs';
import {FondsAnlagestrategieZuzahlung} from '../../../models/fondsAnlagestrategieZuzahlung';
import {FondsPortfolioData} from '../../../models/fondsPortfolioData';
import {TrackingService} from '../../../services/tracking.service';
import {TrackingAktion, TrackingCategory} from '../../../models/enumTracking';

@Component({
    selector: 'lv-kacheln',
    templateUrl: './kacheln.component.html',
    styleUrls: ['./kacheln.component.scss'],
    standalone: false
})
export class KachelnComponent implements OnInit, AfterViewInit {
  @ViewChild(NgForm, {static: true})
  private _ngForm;

  public uiAusrichtung: UIAusrichtung;
  public nestedSymbol: ISymbol;
  public showInfotextCollapsable: boolean = false;
  public controlName: string;
  public isSBShell: boolean;
  public uniqueId: any;

  private _uiArtefakt: Wertemenge;

  constructor(private _validationService: ValidationService,
              private _shellConfigService: ShellConfigService,
              private _uiUpdateService: UiUpdateService,
              private _eventService: EventService,
              private _renderer: Renderer2,
              private _element: ElementRef,
              private _tracker: TrackingService) {
  }

  get uiArtefakt(): Wertemenge {
    return this._uiArtefakt;
  }

  @Input() set uiArtefakt(uiArtefakt: Wertemenge) {
    this._uiArtefakt = uiArtefakt;
  }

  public infotextCollapsableChange(event) {
    this.showInfotextCollapsable = event;
  }

  public ngOnInit(): void {
    this.isSBShell = this._shellConfigService.getParameter().runtimeContext === RuntimeContext.SB_SHELL;
    this.uiAusrichtung = this._shellConfigService.getParameter().uiAusrichtung;
    this.nestedSymbol = firstNestedSymbolControl(this.uiArtefakt.UIArtefakt);
    this._validationService.registerForm(this.uiArtefakt, this._ngForm);
    this.controlName = getHTMLControlName(this.uiArtefakt);
    this.uniqueId = uuid();
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

  clickSelection(event, selection: string) {
    this.trackKachelAuswahl(selection);
    this.uiArtefakt.WertEingabe = selection;
    this._uiUpdateService.valueChangedSubject$.next(this.uiArtefakt);
    if (!!this._uiArtefakt.ReferenzIdentifikator) {
      this._eventService.refIdentTouchedOrDirty$.next(this._uiArtefakt.ReferenzIdentifikator);
    }
  }

  private trackKachelAuswahl(selection: string) {
    if (this.uiArtefakt.FeldnameTracking) {
      this._tracker.trackEvent(TrackingCategory.AKTION_AUSWAHL,
          TrackingAktion.T_LIST, selection + '_' + this.uiArtefakt.FeldnameTracking);
    }
  }
}
